import React from 'react';
import PropTypes from 'prop-types';
import { getMessage } from 'util/locale';
import classNames from 'classnames';

const baseString = 'vra-winfield-link';
const classString = classNames({
  [`${baseString}`]: true
});
const WinfieldLink = ({
  isVisible,
  onClickWinfieldLink
}) => isVisible ? (
  <section
    className={classString}
    onClick={onClickWinfieldLink}>
    <div className={`${baseString}__winfield-logo`}/>
    <p className={`${baseString}__description`}>
      {getMessage('text__winfield-sales-text')}
    </p>
    <span className={`${baseString}__link`}>
      {getMessage('link-text__winfield-r7')}
    </span>
    <div className={`${baseString}__answerplot-logo`}/>
  </section>
) : null;
WinfieldLink.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClickWinfieldLink: PropTypes.func.isRequired
};
export default WinfieldLink;
